/**
 * @fileoverview Vuex getters
 * @module store/getters
 * @see module:store/getters
 */

import store from './index';
import { getStorageAuthInfo } from '@/utils/storageOperateApi';
import { ref } from 'vue';

export default {
  /**
   * 用户信息 仅限用户信息
   * @param {*} state
   * @returns
   */
  userInfo() {
    const userInfo = ref(getStorageAuthInfo());
    store.commit('setUserInfo', userInfo.value?.userinfo);
    return userInfo.value?.userinfo;
  },
  /**
   * 获取用户鉴权信息 包含用户信息 用户菜单 token等信息
   * @param {*} state
   * @returns {*}
   */
  getAuthInfo() {
    const authUserInfo = ref(getStorageAuthInfo());
    store.commit('setAuthUserInfo', authUserInfo.value);
    return authUserInfo.value;
  },
  /**
   * 用户是否有会员权益
   * @param {*} state
   * @returns
   */
  hasMembership(state) {
    return !!state.userMembership?.length;
  },
  // 当前国家化语言是否是英语
  isEnLang() {
    return store.state.lang === 'en-US';
  },
  // 获取搜索唯一标识
  getGlobalSearchId(state) {
    return (sourcePageKey) => state.globalSearchIdMap?.[sourcePageKey] || '';
  },
  hiddenFeartByOrg(state) {
    return state.hiddenFeartByOrg;
  }
};
